import { HttpParams } from '@angular/common/http';
import { TRequestName } from 'src/assets/common/enums/request-names.g';
import { ITabData, TabData, tabData } from './tab-data';

export const tabDataRequest = {
    ...tabData,
    requestName: 'requestName',
    httpParams: 'httpParams',
} as const;

export type TTabDataRequest = (typeof tabDataRequest)[keyof typeof tabDataRequest];

export interface ITabDataRequest extends ITabData
{
    [tabDataRequest.requestName]: TRequestName | string | null;
    [tabDataRequest.httpParams]: HttpParams | null;
}

export class TabDataRequest 
    extends TabData
    implements ITabDataRequest
{
    [tabDataRequest.requestName]: TRequestName | string | null = null;
    [tabDataRequest.httpParams]: HttpParams | null = null;


    constructor()
    constructor(data: Partial<ITabDataRequest> | null)
    constructor(data?: Partial<ITabDataRequest> | null) {
        super((data ?? null) as ITabData);
        if (!data) return;

        Object.assign(this, TabDataRequest.merge(this, data));
    }

    static merge(current: ITabDataRequest, data: Partial<ITabDataRequest>): ITabData {
        const next = {...current};
        next[tabDataRequest.requestName]   = data[tabDataRequest.requestName] ?? null;
        next[tabDataRequest.httpParams] = data[tabDataRequest.httpParams] ?? null;

        return next;
    }
}
